import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";

import "@material/web/button/filled-button.js";

import { sharedStyles, authStyles } from "../styles/shared";

@customElement("not-found-page")
export class NotFoundPage extends LitElement {
  static styles = [sharedStyles, authStyles];

  render() {
    return html`
      <div class="auth-page">
        <div class="auth-card" style="text-align: center;">
          <h1>404</h1>
          <p class="subtitle">
            We couldn't find the page you're looking for.
          </p>
          <a href="/">
            <md-filled-button>Back to dashboard</md-filled-button>
          </a>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "not-found-page": NotFoundPage;
  }
}
